export interface ContextOptions {
  useUserStore: () => unknown
}

export let context: ContextOptions = {
  useUserStore: () => undefined,
}

export const initLayout = async (func: AnyFunction<any>) => {
  context = func()
}
